import { createModel } from "hox";
import { useState } from "react";
import { ITakeMealtDetial, ITakeMealtFields } from "./takeMealtTypes"
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { takeMealtServices } from "./takeMealtServices";
import { ISearchPage } from "@/types/AppTypes";
import { transPgToPagination } from "@/model/globalModel";
import { useLockFn } from "ahooks";
import { globalPrompt } from "@/components/message";
import { userService } from "@/views/user/userService";
import { ISelectOption } from "@/components/YhFormBox/Types";
import { convertRes2Blob } from "@/utils/exportFile";

export const useTakeMealtModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<any[]>();
    //查询条件
    const [searchParam, setSearchParam] = useState<ITakeMealtFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [totalFood, setTotalFood] = useState<any[]>([]);
    //用户列表
    const [userList, setUserList] = useState<any[]>([]);
    const loadData = async (page?: ISearchPage, searchValue: ITakeMealtFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await takeMealtServices.page(searchParams);
        let { data, totalFoods, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setTotalFood(totalFoods ?? [])
        setDataSource(data)
    }

    const userLoadData = async () => {
        let { retData } = await userService.page({
            page: {
                pageSize: 10000,
                pageNum: 1,
            }
        });
        let { data, ...pg } = retData;
        console.log(data)
        setUserList(data.map(item => ({
            label: item.name,
            value: item.id
        })))
    }

    //设置搜索value
    const updateSearchParam = (updateParam: ITakeMealtFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    //导出
    const listExport = async () => {
        const searchValue = {
            ...searchParam,
            page: {
                pageSize: pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let result = await takeMealtServices.export(searchValue);
        convertRes2Blob(result)
    }
    return {
        dataSource, userList, totalFood,
        searchParam,
        initPgCfg,
        pgCfg,
        selectedRowKeys,
        setDataSource,
        setSearchParam,
        setPgCfg,
        loadData,
        updateSearchParam,
        resetSearchParam,
        setSelectedRowKeys,
        userLoadData, listExport
    }
})